import { API_URL } from './constants';

/**
 * Enhanced fetch wrapper with automatic error handling
 * @param url - The URL to fetch
 * @param options - Fetch options
 * @returns Promise that resolves with parsed JSON data
 * @throws Error with message from API or status text
 */
const myFetch = async (url: string, options: RequestInit = {}) => {
  const clientToken = localStorage.getItem('clientToken');
  const userToken = localStorage.getItem('userToken');

  const token = userToken || clientToken;

  const myHeaders = {
    'Content-Type': 'application/json',
    ...(token && {
      Authorization: `Bearer ${token}`,
    }),
  };

  try {
    const response = await fetch(`${API_URL}/api/v6${url}`, {
      method: 'GET',
      ...options,
      headers: {
        ...myHeaders,
        ...options.headers,
      },
    });

    // Try to parse response as JSON
    let data = null;
    const contentType = response.headers.get('content-type');
    if (contentType && contentType.includes('application/json')) {
      data = await response.json();
    } else {
      // For non-JSON responses (like HTML, text, or empty responses)
      const text = await response.text();
      data = text || null;
    }

    // If response is not ok, throw an error with the API message
    if (!response.ok) {
      // Prioritize user-friendly message over error field
      const errorMessage =
        data?.message || data?.error || response.statusText || 'Request failed';

      const error = {} as any;

      error.message = errorMessage;
      error.status = response.status;
      error.statusText = response.statusText;
      error.body = data;

      throw error;
    }

    return data;
  } catch (error: any) {
    if (error.status !== undefined && error.statusText !== undefined) {
      throw error;
    }

    const networkError = {} as any;

    networkError.message = 'Network error. Please check your connection.';
    networkError.status = 0;
    networkError.statusText = 'Network Error';
    networkError.originalError = error;

    throw networkError;
  }
};

export { myFetch };
